import { PaginationQueryDto, type PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { SearchQueryDto, type SearchQueryInterface } from '@zaoblako/shared/common/dtos/search-query.dto';
import { IdsQueryDto, type IdsQueryInterface } from '@zaoblako/shared/common/dtos/ids-query.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';

/** Common dropdown APIs filters query parameters */
export interface DropdownBaseQueryInterface extends PaginationQueryInterface, SearchQueryInterface, IdsQueryInterface {}

/** Common dropdown APIs filters query parameters - DTO schema */
export const DropdownBaseQueryDto = SerdeDtoClass.union<DropdownBaseQueryInterface>(CommonDtoKeysEnum.DROPDOWN_BASE_QUERY_DTO, [
  PaginationQueryDto,
  SearchQueryDto,
  IdsQueryDto,
]);
